import React, { ChangeEvent, useState } from 'react'
import { useEditWebsiteBanner } from './hooks'
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CFormCheck,
  CFormInput,
  CFormSelect,
  CRow,
  CSpinner,
} from '@coreui/react-pro'
import { languages } from '../../../../../libs/languages'
import {
  submitUpdateWebsiteBanner,
  setWebsiteBannerForm,
  $offersByLang,
  offersByLangMounted,
} from './model'
import { FileManagerForm } from '../widgets/FileManagerForm/component'
import { initialWebsiteBannerFile } from '../constants'
import { Flex } from 'antd'
import { WebsiteBannerFile } from '../list/types'
import { useStore } from 'effector-react'
import { getOffers } from '../../offers/list/model'

export const EditWebsiteBanner: React.FC = () => {
  const [validated, setValidated] = useState(false)

  const { websiteBanner, loading } = useEditWebsiteBanner()

  const offersByLang = useStore($offersByLang)
  const offersByLangLoading = useStore(getOffers.pending)

  const [websiteBannerFiles, setWebsiteBannerFiles] = useState<
    WebsiteBannerFile[] | []
  >([])

  const handleChange = (
    event: ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    let value
    const targetName = event.currentTarget.name

    if (event.currentTarget.type === 'checkbox') {
      value = (event.currentTarget as HTMLInputElement).checked
    } else {
      value = event.currentTarget.value
    }

    if (targetName === 'lang') {
      offersByLangMounted({ lang: websiteBanner.lang })
      setWebsiteBannerForm({
        ...websiteBanner,
        offerId: 0,
        [event.currentTarget.name]: value,
      })
    } else {
      setWebsiteBannerForm({
        ...websiteBanner,
        [event.currentTarget.name]: value,
      })
    }
  }

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const form = event.currentTarget

    if (!form.checkValidity()) {
      event.preventDefault()
      event.stopPropagation()
    } else {
      submitUpdateWebsiteBanner({
        lang: websiteBanner.lang,
        title: websiteBanner.title,
        isVisible: websiteBanner.isVisible,
        offerId: Number(websiteBanner.offerId),
      })
      event.preventDefault()
      event.stopPropagation()
    }
    setValidated(true)
  }

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center">
        <CSpinner />
      </div>
    )
  }

  return (
    <CCard className="mb-4">
      <CCardHeader className="d-sm-flex justify-content-between align-items-center">
        <strong>Edit website banner</strong>
      </CCardHeader>
      <CCardBody>
        <CForm noValidate validated={validated} onSubmit={handleSubmit}>
          <CRow className="mb-3">
            <CCol sm={4}>
              <CFormInput
                type="text"
                name="title"
                value={websiteBanner.title}
                onChange={handleChange}
                label="Name"
                minLength={3}
                maxLength={30}
                required
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol sm={4}>
              <CFormSelect
                label="Language"
                name="lang"
                value={websiteBanner.lang}
                onChange={handleChange}
              >
                {languages.map((language) => (
                  <option key={language.value} value={language.value}>
                    {language.label}
                  </option>
                ))}
              </CFormSelect>
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol sm={4}>
              {offersByLangLoading ? (
                <CSpinner color="primary" />
              ) : (
                <CFormSelect
                  label="Offer"
                  name="offerId"
                  value={websiteBanner.offerId}
                  onChange={handleChange}
                >
                  <option>Choose offer</option>
                  {offersByLang?.map((offer) => (
                    <option key={offer.id} value={offer.id}>
                      {offer.title}
                    </option>
                  ))}
                </CFormSelect>
              )}
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol sm={2}>
              <CFormCheck
                name="isVisible"
                checked={websiteBanner.isVisible}
                onChange={handleChange}
                label="Active"
              />
            </CCol>
            <CCol sm={4}>
              <CButton
                className="me-3"
                onClick={() => {
                  setWebsiteBannerFiles((prev) => [
                    ...prev,
                    initialWebsiteBannerFile,
                  ])
                }}
              >
                Added file
              </CButton>
              <CButton
                style={{
                  width: '100px',
                }}
                type="submit"
              >
                Save
              </CButton>
            </CCol>
          </CRow>
        </CForm>
        <div className="mb-3">
          <strong>Files</strong>
        </div>
        <Flex gap={40} wrap="wrap">
          <>
            {websiteBanner?.websiteBannerFiles.map((item) => (
              <FileManagerForm key={item.id} mode={'edit'} data={item} />
            ))}
            {websiteBannerFiles?.map((item, index) => (
              <FileManagerForm key={index} mode={'create'} data={item} />
            ))}
          </>
        </Flex>
      </CCardBody>
    </CCard>
  )
}
